import requestService from "api/request";
import clsx from "clsx";
import useBreakpoint from "hooks/useBreakpoint";
import { formatNumber } from "lib/helpers/format";
import React, { memo, useEffect, useState } from "react";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store";
import { onSetUser } from "store/app";
import CountdownState from "./CountdownState";
import { Tag } from "antd";

const HistoryFuture = () => {
  const breakpoint = useBreakpoint();
  const { user, appGlobal } = useAppSelector((state) => state.app) as any;
  const { t } = useTranslation();
  const [tab, setTab] = useState<string>("pending");
  const dispatch = useAppDispatch();
  const [dataHistory, setDataHistory] = useState<any>([]);
  const [transaction_status, set_transaction_status] = useState<
    "finish" | "pending"
  >("pending");

  const getHistory = async () => {
    try {
      const res = await requestService.get("/profile/getHisotyFutrue", {
        params: {
          transaction_status: transaction_status,
        },
      });
      if (res && res.data) {
        setDataHistory(res.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user) {
      getHistory();
    }
  }, [user, tab, transaction_status]);

  const getUser = async () => {
    try {
      const res = await requestService.get("/profile/me");
      if (res && res.data) {
        dispatch(onSetUser(res?.data?.data));
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
      localStorage.clear();
    }
  };

  const handleCancelTransaction = async (id: any) => {
    try {
      const res = await requestService.post(
        "/trading/handleCancelTransaction/" + id
      );
      if (res && res.data) {
        set_transaction_status("pending");
        await getUser();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPackge = (betId: any) => {
    if (appGlobal.PACKAGE?.length > 0) {
      const data = appGlobal?.PACKAGE?.find((i: any) => betId === i?._id);
      console.log(data);

      return data;
    }
  };
  return (
    <>
      {breakpoint === "desktop" ? (
        <div className="Xbn3jYE2hOjBcifYAYKo">
          <div className="flex flex-col items-start">
            <ul className="urRkCZ1WCFr7IySl9Hu4">
              <li
                className={clsx("aDeHXLmAdqFMn9uaduvR", {
                  yAvMf8HIGOSidXTdxNqo: transaction_status === "pending",
                })}
                onClick={() => set_transaction_status("pending")}
              >
                {t("Lệnh mở")}
                <p className="tJYVNwWu2UY32iGc4j9V">
                  ({dataHistory?.openTotal || 0})
                </p>
              </li>
              <li
                className={clsx("aDeHXLmAdqFMn9uaduvR", {
                  yAvMf8HIGOSidXTdxNqo: transaction_status === "finish",
                })}
                onClick={() => set_transaction_status("finish")}
              >
                {t("Lịch sử lệnh")}
              </li>
              {/* <li
                className={clsx("aDeHXLmAdqFMn9uaduvR", {
                  yAvMf8HIGOSidXTdxNqo: transaction_status === "finish",
                })}
                onClick={() => set_transaction_status("finish")}
              >
                {t("Chi tiết lệnh")}
              </li> */}

              <li className="PsrmLPQYDYtaAdcqoAIc" />
            </ul>
            <div className="LV_np6HCGcCcM3uf_zkv pt-[8px]">
              <div className="EgSedd7cnni5YeKpMzWh DuuQGLsAjzrsCzGQynHy vTZgG9yONPsrKvEhiQwA">
                <div className="Wrapper-sc-19zczuv-0 dCTWnS relative h-[220pxĐ]" />
              </div>
            </div>
          </div>
          <div
            className="TabsContentWapper-sc-ixe2zb-4 kiPPXl h5-tabs-content-warp mt-[10px] px-[10px] "
            style={{ position: "relative" }}
          >
            <div>
              {dataHistory?.transations?.length > 0 &&
                dataHistory?.transations?.map((i: any) => (
                  <div className="text-white mb-4 ">
                    <div className="flex justify-between items-center mb-2">
                      <p className="font-[500] text-[15px]">{i?.symbol}</p>
                      {transaction_status === "finish" ? (
                        <p className="cursor-pointer text-[14px]">
                          {i?.value > 0 ? (
                            <Tag color="green-inverse">Thắng</Tag>
                          ) : (
                            <Tag color="red-inverse">Thua</Tag>
                          )}
                        </p>
                      ) : (
                        <p className="cursor-pointer text-[14px]">
                          {transaction_status === "pending" && (
                            <CountdownState
                              transaction_status={transaction_status}
                              getHistory={getHistory}
                              i={i}
                            />
                          )}
                        </p>
                      )}
                    </div>
                    <div className="flex gap-2 items-center mb-2">
                      {i?.bet_condition === "buy" && (
                        <>
                          <div className="bg-green-400 p-1.5 rounded-md text-[10px]">
                            {t("Mua")}
                          </div>
                        </>
                      )}

                      {i?.bet_condition === "sell" && (
                        <>
                          <div className="bg-red-500 p-1.5 rounded-md text-[10px]">
                            {t("Bán")}
                          </div>
                        </>
                      )}

                      <div className="text-[10px] text-[#ccc]">
                        {new Date(i?.createdAt)?.toLocaleString()}
                      </div>
                    </div>
                    <div className="flex gap-2 items-center">
                      <div className="flex items-center gap-4">
                        <div className="text-[13px]">
                          <p className="text-[13px]">{t("Số lượng đặt")}</p>
                          <p className="text-[13px]">
                            {formatNumber(i?.bet_value?.toFixed(3))}
                          </p>
                        </div>
                        <div>
                          <p className="text-[13px]">
                            {t(" Lợi nhuận Lãi/lỗ")}{" "}
                          </p>
                          <p className="text-[13px]">
                            {formatNumber(i?.value?.toFixed(3))}
                          </p>
                        </div>
                      </div>
                      <div className="flex-1 flex justify-end">
                        <div className="flex flex-col gap-2">
                          <div>
                            <p className="text-[13px]">{t("Giá mở")}</p>
                            <p className="text-[13px]">
                              {formatNumber(i?.open_price?.toFixed(3))}
                            </p>
                          </div>
                          <div>
                            <p className="text-[13px]">{t("Giá đóng")}</p>
                            <p className="text-[13px]">
                              {formatNumber(i?.close_price?.toFixed(3))}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="LayoutCenterRow-sc-1duum9t-3 kTDTMU"
          style={{ flex: "1 1 0%" }}
        >
          <div
            className="LayoutCenterCol-sc-1duum9t-2 iKvsPN"
            style={{
              flex: "1 1 0%",
              overflowX: "auto",
            }}
          >
            <div className="position-list-warp">
              <div>
                <div className="h5-tabs ">
                  <div className="FlexStartDiv-sc-1yxfzbf-1 TabsTitWrapper-sc-ixe2zb-1 jyTYKe">
                    <div className="h-[41px] border-b-0 rounded-[4px] flex relative justify-start items-center">
                      <div
                        className="rc-scrollbars-container h5-spot-tabs-scrollbars"
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <div
                          className="rc-scrollbars-view"
                          style={{
                            position: "absolute",
                            inset: 0,
                            overflow: "scroll",
                            marginRight: "-5px",
                            marginBottom: "-5px",
                          }}
                        >
                          <div
                            className={clsx(
                              "text-[15px] leading-[40px] mx-[9px] inline-block font-[500] cursor-pointer text-center text-[rgb(255,255,255)] ",
                              {
                                "border-b-[2px] border-[#fff]":
                                  transaction_status === "pending",
                              }
                            )}
                            onClick={() => set_transaction_status("pending")}
                          >
                            {t("Lệnh mở")}
                            <p className="tJYVNwWu2UY32iGc4j9V">
                              ({dataHistory?.openTotal || 0})
                            </p>
                          </div>
                          <div
                            className={clsx(
                              "text-[15px] leading-[40px] mx-[9px] inline-block font-[500] cursor-pointer text-center text-[rgb(255,255,255)] ",
                              {
                                "border-b-[2px] border-[#fff]":
                                  transaction_status === "finish",
                              }
                            )}
                            onClick={() => set_transaction_status("finish")}
                          >
                            {t("Lịch sử lệnh")}
                          </div>
                          <div
                            className={clsx(
                              "text-[15px] leading-[40px] mx-[9px] inline-block font-[500] cursor-pointer text-center text-[rgb(255,255,255)] "
                            )}
                          >
                            {t("Chi tiết lệnh")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {breakpoint === "mobile" && (
        <div
          className="TabsContentWapper-sc-ixe2zb-4 kiPPXl h5-tabs-content-warp mt-[10px] px-[10px] "
          style={{ position: "relative" }}
        >
          <div>
            {dataHistory?.transations?.length > 0 &&
              dataHistory?.transations?.map((i: any) => (
                <div className="text-white mb-4 ">
                  <div className="flex justify-between items-center mb-2">
                    <p className="font-[500] text-[15px]">{i?.symbol}</p>
                    {/* {transaction_status === "finish" ? (
                      <p className="cursor-pointer text-[14px]">
                        {t("Đã khớp")}
                      </p>
                    ) : (
                      <p
                        className="cursor-pointer text-[14px]"
                        onClick={() => handleCancelTransaction(i?._id)}
                      >
                        {t("Hủy")}
                      </p>
                    )} */}
                  </div>
                  <div className="flex gap-2 items-center mb-2">
                    {i?.bet_condition === "buy" && (
                      <>
                        {/* <div className="bg-green-400 rounded-md p-1.5 text-[10px]">
                          Limit
                        </div> */}
                        <div className="bg-green-400 p-1.5 rounded-md text-[10px]">
                          {t("Mua")}
                        </div>
                      </>
                    )}

                    {i?.bet_condition === "sell" && (
                      <>
                        {/* <div className="bg-red-500 rounded-md p-1.5 text-[10px]">
                          Limit
                        </div> */}
                        <div className="bg-red-500 p-1.5 rounded-md text-[10px]">
                          {t("Bán")}
                        </div>
                      </>
                    )}

                    <div className="text-[10px] text-[#ccc]">
                      {new Date(i?.createdAt)?.toLocaleString()}
                    </div>
                  </div>
                  <div className="flex gap-2 items-center">
                    <div className="flex items-center gap-4">
                      <div>
                        <p className="text-[13px]">{t("Số tiền đặt lệnh")} </p>
                        <p className="text-[13px]">
                          {formatNumber(i?.bet_value?.toFixed(3))}
                        </p>
                      </div>
                      <div className="text-[13px]">
                        <p className="text-[13px]">{t(" Lợi nhuận Lãi/lỗ")}</p>
                        <p className="text-[13px]">
                          {formatNumber(i?.value?.toFixed(3))}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-col gap-2 flex-1  justify-end">
                      <div className="flex-1 flex justify-end">
                        <div>
                          <p className="text-[13px]">{t("Giá mở")}</p>
                          <p className="text-[13px]">
                            {formatNumber(i?.open_price?.toFixed(3))}
                          </p>
                        </div>
                      </div>
                      <div className="flex-1 flex justify-end">
                        <div>
                          <p className="text-[13px]">{t("Giá đóng")}</p>
                          <p className="text-[13px]">
                            {formatNumber(i?.close_price?.toFixed(3))}
                          </p>
                        </div>
                      </div>
                      <div className="flex-1 flex justify-end">
                        {transaction_status === "finish" ? (
                          <p className="cursor-pointer text-[14px]">
                            {i?.value > 0 ? (
                              <Tag color="green-inverse">Thắng</Tag>
                            ) : (
                              <Tag color="red-inverse">Thua</Tag>
                            )}
                          </p>
                        ) : (
                          <p className="cursor-pointer text-[14px]">
                            {transaction_status === "pending" && (
                              <CountdownState
                                transaction_status={transaction_status}
                                getHistory={getHistory}
                                i={i}
                              />
                            )}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default memo(HistoryFuture);
